import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhysicalInfrastructureRoutingModule } from './physical-infrastructure-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/material.module';
import { PhysicalInfraPageComponent } from './components/physical-infra-page/physical-infra-page.component';
import { AdminPhysicalInfraComponent } from './components/admin-physical-infra/admin-physical-infra.component';


@NgModule({
  declarations: [ PhysicalInfraPageComponent, AdminPhysicalInfraComponent],
  imports: [
    CommonModule,
    PhysicalInfrastructureRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class PhysicalInfrastructureModule { }
